import { Outlet } from 'react-router';

export const AdminLayout = () => <Outlet />;
